import rootConfig from 'root/cenco.config';

const api = Object.assign({}, rootConfig.api)

const apiKey = Object.assign({}, rootConfig.apikey);

const token = {
    homeQA: 'g5p2pj0h8WIaBE4cP2HR',
    liveSale: 'n8BAnrYaEsfa72I7iFcw',
    liveSaleDev: 'n8BAnrYaEsfa72I7iFcw'
}

export {
    api,
    apiKey,
    token
}